import { PublicMobileShell } from "../components/PublicMobileShell";

const SECTIONS = [
  { t: "1. Kateri podatki", c: "Zbiramo e-pošto, ime, evidenco odstrela, poti in načrte; lokacijo naprave med uporabo karte oziroma lova; slike odstrela." },
  { t: "2. Namen obdelave", c: "Podatke uporabljamo izključno za delovanje aplikacije (karta, lokacije, evidenca, statistika, sinhronizacija). Lokacije ne uporabljamo za oglaševanje." },
  { t: "3. Deljenje lokacije", c: "Med aktivnim lovom je vaša lokacija vidna le članom istega lova; ob izhodu iz lova se deljenje prekine." },
  { t: "4. Tretje osebe", c: "Podatkov ne prodajamo. Uporabljamo ponudnika infrastrukture, vremenske vire (Open-Meteo, MET Norway), karte (ZGS) in obdelavo naročnin (RevenueCat, App Store, Google Play)." },
  { t: "5. Hramba in izbris", c: "Podatke hranimo do obstoja računa; uporabnik lahko kadar koli trajno izbriše račun in podatke neposredno v aplikaciji." },
  { t: "6. Dovoljenja", c: "Aplikacija uporablja dovoljenja: lokacija, kamera (slike odstrela, QR vezice) in fotografije. Vsa dovoljenja lahko kadar koli spremenite v nastavitvah naprave." },
  { t: "7. Vaše pravice", c: "Imate pravico do vpogleda, popravka in izbrisa svojih podatkov. Pišite nam na info@doberpogled.app." },
  { t: "8. Upravljavec", c: "Upravljavec podatkov je ekipa Dober Pogled, info@doberpogled.app." },
];

export default function ZasebnostPage() {
  return (
    <PublicMobileShell>
      <div className="max-w-3xl mx-auto px-4 py-12 md:py-16 space-y-8" data-testid="zasebnost-page">
        <div className="space-y-2">
          <h1 className="text-4xl sm:text-5xl font-bold text-emerald-900 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Politika zasebnosti — Dober Pogled (mobilna aplikacija)
          </h1>
          <p className="text-sm text-slate-500">Datum: junij 2026</p>
        </div>

        <div className="space-y-6">
          {SECTIONS.map((s) => (
            <section key={s.t} data-testid={`zasebnost-sekcija-${s.t[0]}`}>
              <h2 className="font-semibold text-emerald-900 text-lg mb-1.5">{s.t}</h2>
              <p className="text-sm md:text-base text-slate-600 leading-relaxed">{s.c}</p>
            </section>
          ))}
        </div>
      </div>
    </PublicMobileShell>
  );
}
